import { createSelector } from '@reduxjs/toolkit'
import { pathname$ } from '../reducers/browser-info.slice'

export const shouldShowFooter$ = /*@__PURE__*/ createSelector(
	pathname$,
	(p) => p != '/' && !p.startsWith('/pair') && !['/forgot', '/reset', '/verify'].includes(p),
)

export const isFullWidthLandingView$ = /*@__PURE__*/ createSelector(
	pathname$,
	(pathname) => pathname === '/',
)

export const isPromoPage$ = /*@__PURE__*/ createSelector(pathname$, (p) => p.startsWith('/promo'))
